import CONFIG from "./../config.json";

function empGetEditorUrl(language = document.documentElement.lang) {
    return language && language.substring(0, 2).toLowerCase() === "es"
        ? "https://editor.yuppiya.com/es.html"
        : "https://editor.yuppiya.com/ca.html";
}

function empOnClickLink(event, element) {
    event.preventDefault();

    var overlay = document.createElement('div');
    overlay.style.position = 'fixed';
    overlay.style.top = '0';
    overlay.style.left = '0';
    overlay.style.width = '100%';
    overlay.style.height = '100%';
    overlay.style.backgroundColor = 'rgba(0, 0, 0, 0.5)';
    overlay.style.backdropFilter = 'blur(10px)';
    overlay.style.zIndex = '999';
    overlay.style.display = 'flex';
    overlay.style.flexDirection = 'column';
    overlay.style.justifyContent = 'center';
    overlay.style.alignItems = 'center';

    var loadingImage = document.createElement('img');
    loadingImage.src = '../cartells-192-v2.png';
    loadingImage.alt = 'Loading...';
    loadingImage.style.marginBottom = '20px';
    
    var linkImage = document.createElement('a');
    linkImage.href = 'https://cartells.yuppiya.com';

    var link2 = document.createElement('a');
    link2.href = empGetEditorUrl();
    link2.innerText = 'editor.yuppiya.com';
    link2.style.color = 'white';
    link2.style.textDecoration = 'none';
    link2.style.marginBottom = '10px';

    var link1 = document.createElement('a');
    link1.href = 'https://cartells.yuppiya.com';
    link1.innerText = 'cartells.yuppiya.com';
    link1.style.color = 'white';
    link1.style.textDecoration = 'none';
   
    linkImage.appendChild(loadingImage);
    overlay.appendChild(linkImage);
    overlay.appendChild(link2);
    overlay.appendChild(link1);

    document.body.appendChild(overlay);

    window.location.href = element.href;
}



function empEditorWakeUp()
{
    fetch(CONFIG.posters_editor_url, {
        mode: "no-cors",
        keepalive: true
    }).catch(() => {
        // Best effort warm-up.
    });
}

export { empGetEditorUrl, empOnClickLink, empEditorWakeUp };
